import { type ReactNode } from 'react';

import { trackEvent, eventNameConstants, interactionTypeConstants } from 'dibs-tracking';
import { Link } from 'dibs-elements/exports/Link.tsx';

export const getPurchaseProtectionLink =
    (stepInteractionName: string, dataTn?: string) =>
    (chunk: ReactNode): ReactNode => (
        <Link
            dataTn={dataTn}
            href="/about/purchase-protection/"
            target="_blank"
            onClick={() => {
                trackEvent({
                    eventName: eventNameConstants.EVENT_PRODUCT_INTERACTION,
                    interaction_type: interactionTypeConstants.INTERACTION_TYPE_EBI_DETAILS,
                    step_interaction_name: stepInteractionName,
                });
            }}
        >
            {chunk}
        </Link>
    );
